module.exports = __webpack_public_path__ + "img/electronic_pending_zone.cab92f81.svg";